module.exports = {
	"id": "IQ",
	"name": "Iraq",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.007632,
			"6": 0.007632,
			"7": null,
			"8": 0.005088,
			"9": 0.002544,
			"10": 0.005088,
			"11": 0.033072,
			"12": 0.005088,
			"13": 0.017808,
			"14": 0.01272,
			"15": 0.010176,
			"16": 0.005088,
			"17": 0.005088,
			"18": 0.01272,
			"19": 0.015264,
			"20": 0.01272,
			"21": 0.017808,
			"22": 0.020352,
			"23": 0.015264,
			"24": 0.015264,
			"25": 0.022896,
			"26": 0.010176,
			"27": 0.017808,
			"28": 0.01272,
			"29": 0.02544,
			"30": 0.033072,
			"31": 0.071232,
			"32": 0.022896,
			"33": 0.117024,
			"34": 0.03816,
			"35": 0.01272,
			"36": 0.010176,
			"37": 0.005088,
			"38": 0.086496,
			"39": 0.030528,
			"40": 0.03816,
			"41": 0.017808,
			"42": 0.022896,
			"43": 1.562016,
			"44": 0.035616,
			"45": 0.053424,
			"46": 0.033072,
			"47": 0.073776,
			"48": 0.05088,
			"49": 0.284928,
			"50": 0.055968,
			"51": 0.625824,
			"52": 0.213696,
			"53": 10.812,
			"54": 2.984112,
			"55": 0.0636,
			"56": 0.020352,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.002544,
			"4": 0.002544,
			"5": 0.007632,
			"6": 0.020352,
			"7": null,
			"8": 0.002544,
			"9": 0.002544,
			"10": 0.005088,
			"11": 0.007632,
			"12": 0.022896,
			"13": 0.015264,
			"14": 0.007632,
			"15": 0.007632,
			"16": 0.002544,
			"17": 0.002544,
			"18": 0.01272,
			"19": 0.005088,
			"20": 0.005088,
			"21": 0.002544,
			"22": 0.005088,
			"23": 0.005088,
			"24": 0.005088,
			"25": 0.005088,
			"26": 0.005088,
			"27": 0.007632,
			"28": 0.002544,
			"29": 0.010176,
			"30": 0.017808,
			"31": 0.015264,
			"32": 0.010176,
			"33": 0.022896,
			"34": 0.010176,
			"35": 0.010176,
			"36": 0.007632,
			"37": 0.030528,
			"38": 0.022896,
			"39": 0.017808,
			"40": 0.010176,
			"41": 0.015264,
			"42": 0.015264,
			"43": 0.099216,
			"44": 0.058512,
			"45": 0.045792,
			"46": 0.043248,
			"47": 0.300192,
			"48": 0.208608,
			"49": 2.004672,
			"50": 0.180624,
			"51": 0.002544,
			"52": null,
			"3.5": null,
			"3.6": 0.015264
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.010176,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.002544,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.002544,
			"35": null,
			"36": 0.01272,
			"37": 0.015264,
			"38": 0.020352,
			"39": 0.017808,
			"40": 0.36888,
			"41": 0.066144,
			"42": 0.002544,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.010176
		},
		"safari": {
			"0": null,
			"4": 0.005088,
			"5": null,
			"6": null,
			"7": 0.002544,
			"8": 0.01272,
			"9": 0.010176,
			"10": 0.094128,
			"3.1": null,
			"3.2": null,
			"5.1": 0.007632,
			"6.1": null,
			"7.1": null,
			"9.1": 0.045792
		},
		"ios_saf": {
			"8": 0,
			"10": 9.95934113572,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.2683927194,
			"8.1-8.4": 0.49584417652,
			"9.0-9.2": 0.236549515404,
			"9.3": 3.60889645296
		},
		"android": {
			"3": 0,
			"4": 0.153204423773,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0191505529716,
			"4.1": 0.552630242894,
			"4.2-4.3": 1.38157560724,
			"4.4": 3.16804862016,
			"4.4.3-4.4.4": 3.19540655297
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.164930191781,
			"9": 0.085125260274,
			"10": 0.0691642739726,
			"11": 0.845932273973,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0411348386291,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00114263440636
		},
		"edge": {
			"12": 0.035616,
			"13": 0.08904,
			"14": 0.13992
		},
		"ie_mob": {
			"10": 0.0323443380282,
			"11": 0.131687661972
		},
		"bb": {
			"7": 0.003728,
			"10": null
		},
		"samsung": {
			"0": 8.678784
		},
		"and_uc": {
			"0": 0.48464
		},
		"op_mini": {
			"0": 0.554202526965
		},
		"and_chr": {
			"0": 42.933872
		},
		"and_ff": {
			"0": 0.044736
		}
	},
	"total": 99.118608
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IQ.json
 ** module id = 552
 ** module chunks = 0
 **/